export const deClientPortalValuationDCFPage = {
    table: {
        columnLabels: {
            period: 'Periode {{period}}',
            exit: 'Exit',
        },
        sections: {
            marketRent: 'Marktmiete',
            revenue: 'Erträge',
            costs: 'Kosten',
            presentValueCalculation: 'Barwertberechnung',
        },
        rows: {
            grossRevenue: 'Bruttoertrag',
            totalCosts: 'Gesamtkosten',
            discountFactor: 'Diskontierungsfaktor',
            totalNetRevenue: 'Total Nettoertrag',
            presentValue: 'Barwert',
            terminalValue: 'Endwert/Ewige Rente',
            presentValueTotal: 'Summe Barwert',
            presentValueAfterTransactionCosts: 'Summe Barwert abzügl. Erwerbsnebenkosten',
            rounded: 'Gerundet',
        },
    },
}
